const decodeHtmlEntities = (value) => {
    if (typeof value !== 'string') {
        return value;
    }
    const element = document.createElement('textarea');
    element.innerHTML = value;
    return element.value;
};

const decodeArticleOutput = (output) => {
    output.blocks.forEach((block) => {
        if (block.type !== 'image' || !block.data) {
            return;
        }

        const { data } = block;

        if (data.product?.name) {
            data.product.name = decodeHtmlEntities(data.product.name);
        }
        if (data.license) {
            data.license = decodeHtmlEntities(data.license);
        }
    });

    return output;
};

export default decodeArticleOutput;
